<template>
    <div class="text-center">
        <div v-for="s in steps" class="number-cont">
            <span class="number" :class="{active: s <= step}">{{s}}</span>
            <span v-if="s < steps" class="divider" :class="{active: s < step}"></span>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'StepIndicator',
        props: {
            steps: {default: 3},
            step: {default: 1}
        },
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    }
</script>

<style lang="sass">

    @import "../../assets/sass/vars.scss"

    .number-cont
        display: inline-block

    .number
        display: block
        float: left
        border-radius: 50%
        font-size: 2em
        width: 1.7em
        height: 1.7em
        border: 1px solid #ccc

        &.active
            background-color: $colorPrimary
            border-color: $colorPrimary
            color: #FFF

    .divider
        display: block
        float: left
        padding-top: 1.7em
        border-bottom: 2px solid #ccc
        //margin-top: .5em
        width: 1.3em
        &.active
            border-color: $colorPrimary



</style>


// WEBPACK FOOTER //
// src/components/ui/StepIndicator.vue